export const ExcelIcon: React.FC<{ color?: string; size?: number }> = ({
  size = 40,
  color = "#009CA7",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.172 0C23.7022 0 24.2107 0.210507 24.5857 0.585255L36.4137 12.4044C36.7891 12.7795 37 13.2884 37 13.8191V35.3333C37 37.9107 34.8689 40 32.24 40H7.76C5.13112 40 3 37.9107 3 35.3333V4.66667C3 2.08934 5.13112 0 7.76 0H23.172Z"
      fill={color}
    />
    <g filter="url(#filter0_d_excel)">
      <path
        d="M35.1548 12.1381C35.4678 12.4537 35.2443 12.9902 34.7998 12.9902H29C26.4227 12.9902 24.0976 10.7233 24.0976 8.21031V2.20435C24.0976 1.75791 24.6382 1.53528 24.9526 1.85224L35.1548 12.1381Z"
        fill="white"
        fillOpacity="0.24"
        shapeRendering="crispEdges"
      />
    </g>
    <path
      d="M23.9959 16L23.9956 16.0112L24 16.0113V30H22.8337L22.8336 29.9983H19.3263L18.1603 30L18.1601 29.9983H15.8517L14.6855 30L14.6854 29.9983H11.1701L10.0041 30L10.0039 29.9983L10.0017 28.8328L10.0039 28.8326V25.3104L10.0009 24.1449L10.0039 24.1447V20.6224L10 20.6227V19.457L10.0039 19.4568V17.1657L10 17.1657V16H23.9959ZM14.6854 25.3104H11.1701V28.8326H14.6854V25.3104ZM18.1601 25.3104H15.8517V28.8326H18.1601V25.3104ZM22.8336 25.3104H19.3263V28.8326H22.8336V25.3104ZM14.6854 20.6224H11.1701V24.1447H14.6854V20.6224ZM18.1601 20.6224H15.8517V24.1447H18.1601V20.6224ZM22.8336 20.6224H19.3263V24.1447H22.8336V20.6224ZM22.8336 17.1657H11.1701V19.4568H22.8336V17.1657Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_excel"
        x="22.0977"
        y="1.70337"
        width="15.2031"
        height="15.2869"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_excel"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_excel"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
